/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/webpack/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 368);
/******/ })
/************************************************************************/
/******/ ({

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*** IMPORTS FROM imports-loader ***/
(function () {

  __webpack_require__(11);

  /* global droplabFilter */

  (function () {
    var DropdownHint = function (_gl$FilteredSearchDro) {
      _inherits(DropdownHint, _gl$FilteredSearchDro);

      function DropdownHint(droplab, dropdown, input, filter) {
        _classCallCheck(this, DropdownHint);

        var _this = _possibleConstructorReturn(this, (DropdownHint.__proto__ || Object.getPrototypeOf(DropdownHint)).call(this, droplab, dropdown, input, filter));

        _this.config = {
          droplabFilter: {
            template: 'hint',
            filterFunction: gl.DropdownUtils.filterHint.bind(null, input)
          }
        };
        return _this;
      }

      _createClass(DropdownHint, [{
        key: 'itemClicked',
        value: function itemClicked(e) {
          var selected = e.detail.selected;


          if (selected.tagName === 'LI') {
            if (selected.hasAttribute('data-value')) {
              this.dismissDropdown();
            } else if (selected.getAttribute('data-action') === 'submit') {
              this.dismissDropdown();
              this.dispatchFormSubmitEvent();
            } else {
              var token = selected.querySelector('.js-filter-hint').innerText.trim();
              var tag = selected.querySelector('.js-filter-tag').innerText.trim();

              if (tag.length) {
                gl.FilteredSearchDropdownManager.addWordToInput(token.replace(':', ''));
              }
              this.dismissDropdown();
              this.dispatchInputEvent();
            }
          }
        }
      }, {
        key: 'renderContent',
        value: function renderContent() {
          var dropdownData = [{
            icon: 'fa-pencil',
            hint: 'author:',
            tag: '&lt;@author&gt;'
          }, {
            icon: 'fa-user',
            hint: 'assignee:',
            tag: '&lt;@assignee&gt;'
          }, {
            icon: 'fa-clock-o',
            hint: 'milestone:',
            tag: '&lt;%milestone&gt;'
          }, {
            icon: 'fa-tag',
            hint: 'label:',
            tag: '&lt;~label&gt;'
          }];

          this.droplab.changeHookList(this.hookId, this.dropdown, [droplabFilter], this.config);
          this.droplab.setData(this.hookId, dropdownData);
        }
      }, {
        key: 'init',
        value: function init() {
          this.droplab.addHook(this.input, this.dropdown, [droplabFilter], this.config).init();
        }
      }]);

      return DropdownHint;
    }(gl.FilteredSearchDropdown);

    window.gl = window.gl || {};
    gl.DropdownHint = DropdownHint;
  })();
}).call(window);

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    var DATA_DROPDOWN_TRIGGER = 'data-dropdown-trigger';

    var FilteredSearchDropdown = function () {
      function FilteredSearchDropdown(droplab, dropdown, input, filter) {
        _classCallCheck(this, FilteredSearchDropdown);

        this.droplab = droplab;
        this.hookId = input && input.getAttribute('data-id');
        this.input = input;
        this.filter = filter;
        this.dropdown = dropdown;
        this.loadingTemplate = '<div class="filter-dropdown-loading">\n        <i class="fa fa-spinner fa-spin"></i>\n      </div>';
        this.bindEvents();
      }

      _createClass(FilteredSearchDropdown, [{
        key: 'bindEvents',
        value: function bindEvents() {
          this.itemClickedWrapper = this.itemClicked.bind(this);
          this.dropdown.addEventListener('click.dl', this.itemClickedWrapper);
        }
      }, {
        key: 'unbindEvents',
        value: function unbindEvents() {
          this.dropdown.removeEventListener('click.dl', this.itemClickedWrapper);
        }
      }, {
        key: 'getCurrentHook',
        value: function getCurrentHook() {
          var _this = this;

          return this.droplab.hooks.filter(function (h) {
            return h.id === _this.hookId;
          })[0] || null;
        }
      }, {
        key: 'itemClicked',
        value: function itemClicked(e, getValueFunction) {
          var selected = e.detail.selected;


          if (selected.tagName === 'LI' && selected.innerHTML) {
            var dataValueSet = gl.DropdownUtils.setDataValueIfSelected(this.filter, selected);

            if (!dataValueSet) {
              var value = getValueFunction(selected);
              gl.FilteredSearchDropdownManager.addWordToInput(this.filter, value);
            }

            this.dismissDropdown();
            this.dispatchInputEvent();
          }
        }
      }, {
        key: 'setAsDropdown',
        value: function setAsDropdown() {
          this.input.setAttribute(DATA_DROPDOWN_TRIGGER, '#' + this.dropdown.id);
        }
      }, {
        key: 'setOffset',
        value: function setOffset() {
          var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          this.dropdown.style.left = offset + 'px';
        }
      }, {
        key: 'renderContent',
        value: function renderContent() {
          var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

          if (forceShowList && this.getCurrentHook().list.hidden) {
            this.getCurrentHook().list.show();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var forceRenderContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          var forceShowList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

          this.setAsDropdown();

          var currentHook = this.getCurrentHook();
          var firstTimeInitialized = currentHook === null;

          if (firstTimeInitialized || forceRenderContent) {
            this.renderContent(forceShowList);
          } else if (currentHook.list.list.id !== this.dropdown.id) {
            this.renderContent(forceShowList);
          }
        }
      }, {
        key: 'dismissDropdown',
        value: function dismissDropdown() {
          // Focusing on the input will dismiss dropdown
          // (default droplab functionality)
          this.input.focus();
        }
      }, {
        key: 'dispatchInputEvent',
        value: function dispatchInputEvent() {
          // Propogate input change to FilteredSearchDropdownManager
          // so that it can determine which dropdowns to open
          this.input.dispatchEvent(new CustomEvent('input', {
            bubbles: true,
            cancelable: true
          }));
        }
      }, {
        key: 'dispatchFormSubmitEvent',
        value: function dispatchFormSubmitEvent() {
          // dispatchEvent() is necessary as form.submit() does not
          // trigger event handlers
          this.input.form.dispatchEvent(new Event('submit'));
        }
      }, {
        key: 'hideDropdown',
        value: function hideDropdown() {
          this.getCurrentHook().list.hide();
        }
      }, {
        key: 'resetFilters',
        value: function resetFilters() {
          var hook = this.getCurrentHook();
          var data = hook.list.data;
          var results = data.map(function (o) {
            var updated = o;
            updated.droplab_hidden = false;
            return updated;
          });
          hook.list.render(results);
        }
      }]);

      return FilteredSearchDropdown;
    }();

    window.gl = window.gl || {};
    gl.FilteredSearchDropdown = FilteredSearchDropdown;
  })();
}).call(window);

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*** IMPORTS FROM imports-loader ***/
(function () {

  __webpack_require__(11);

  /* global droplabAjax */
  /* global droplabFilter */

  (function () {
    var DropdownNonUser = function (_gl$FilteredSearchDro) {
      _inherits(DropdownNonUser, _gl$FilteredSearchDro);

      function DropdownNonUser(droplab, dropdown, input, filter, endpoint, symbol) {
        _classCallCheck(this, DropdownNonUser);

        var _this = _possibleConstructorReturn(this, (DropdownNonUser.__proto__ || Object.getPrototypeOf(DropdownNonUser)).call(this, droplab, dropdown, input, filter));

        _this.symbol = symbol;
        _this.config = {
          droplabAjax: {
            endpoint: endpoint,
            method: 'setData',
            loadingTemplate: _this.loadingTemplate
          },
          droplabFilter: {
            filterFunction: gl.DropdownUtils.filterWithSymbol.bind(null, _this.symbol, input)
          }
        };
        return _this;
      }

      _createClass(DropdownNonUser, [{
        key: 'itemClicked',
        value: function itemClicked(e) {
          var _this2 = this;

          _get(DropdownNonUser.prototype.__proto__ || Object.getPrototypeOf(DropdownNonUser.prototype), 'itemClicked', this).call(this, e, function (selected) {
            var title = selected.querySelector('.js-data-value').innerText.trim();
            return '' + _this2.symbol + gl.DropdownUtils.getEscapedText(title);
          });
        }
      }, {
        key: 'renderContent',
        value: function renderContent() {
          var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

          this.droplab.changeHookList(this.hookId, this.dropdown, [droplabAjax, droplabFilter], this.config);
          _get(DropdownNonUser.prototype.__proto__ || Object.getPrototypeOf(DropdownNonUser.prototype), 'renderContent', this).call(this, forceShowList);
        }
      }, {
        key: 'init',
        value: function init() {
          this.droplab.addHook(this.input, this.dropdown, [droplabAjax, droplabFilter], this.config).init();
        }
      }]);

      return DropdownNonUser;
    }(gl.FilteredSearchDropdown);

    window.gl = window.gl || {};
    gl.DropdownNonUser = DropdownNonUser;
  })();
}).call(window);

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*** IMPORTS FROM imports-loader ***/
(function () {

  __webpack_require__(11);

  /* global droplabAjaxFilter */

  (function () {
    var DropdownUser = function (_gl$FilteredSearchDro) {
      _inherits(DropdownUser, _gl$FilteredSearchDro);

      function DropdownUser(droplab, dropdown, input, filter) {
        _classCallCheck(this, DropdownUser);

        var _this = _possibleConstructorReturn(this, (DropdownUser.__proto__ || Object.getPrototypeOf(DropdownUser)).call(this, droplab, dropdown, input, filter));

        _this.config = {
          droplabAjaxFilter: {
            endpoint: (gon.relative_url_root || '') + '/autocomplete/users.json',
            searchKey: 'search',
            params: {
              per_page: 20,
              active: true,
              project_id: _this.getProjectId(),
              current_user: true
            },
            searchValueFunction: _this.getSearchInput.bind(_this),
            loadingTemplate: _this.loadingTemplate
          }
        };
        return _this;
      }

      _createClass(DropdownUser, [{
        key: 'itemClicked',
        value: function itemClicked(e) {
          _get(DropdownUser.prototype.__proto__ || Object.getPrototypeOf(DropdownUser.prototype), 'itemClicked', this).call(this, e, function (selected) {
            return selected.querySelector('.dropdown-light-content').innerText.trim();
          });
        }
      }, {
        key: 'renderContent',
        value: function renderContent() {
          var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

          this.droplab.changeHookList(this.hookId, this.dropdown, [droplabAjaxFilter], this.config);
          _get(DropdownUser.prototype.__proto__ || Object.getPrototypeOf(DropdownUser.prototype), 'renderContent', this).call(this, forceShowList);
        }
      }, {
        key: 'getProjectId',
        value: function getProjectId() {
          return this.input.getAttribute('data-project-id');
        }
      }, {
        key: 'getSearchInput',
        value: function getSearchInput() {
          var query = gl.DropdownUtils.getSearchInput(this.input);

          var _gl$FilteredSearchTok = gl.FilteredSearchTokenizer.processTokens(query),
              lastToken = _gl$FilteredSearchTok.lastToken;

          var value = lastToken.value || '';

          // Removes the first character if it is a quotation so that we can search
          // with multiple words
          if (value[0] === '"' || value[0] === '\'') {
            value = value.slice(1);
          }

          return value;
        }
      }, {
        key: 'init',
        value: function init() {
          this.droplab.addHook(this.input, this.dropdown, [droplabAjaxFilter], this.config).init();
        }
      }]);

      return DropdownUser;
    }(gl.FilteredSearchDropdown);

    window.gl = window.gl || {};
    gl.DropdownUser = DropdownUser;
  })();
}).call(window);

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    var DropdownUtils = function () {
      function DropdownUtils() {
        _classCallCheck(this, DropdownUtils);
      }

      _createClass(DropdownUtils, null, [{
        key: 'getEscapedText',
        value: function getEscapedText(text) {
          var escapedText = text;
          var hasSpace = text.indexOf(' ') !== -1;
          var hasDoubleQuote = text.indexOf('"') !== -1;

          // Encapsulate value with quotes if it has spaces
          // Known side effect: values's with both single and double quotes
          // won't escape properly
          if (hasSpace) {
            if (hasDoubleQuote) {
              escapedText = '\'' + text + '\'';
            } else {
              // Encapsulate singleQuotes or if it hasSpace
              escapedText = '"' + text + '"';
            }
          }

          return escapedText;
        }
      }, {
        key: 'filterWithSymbol',
        value: function filterWithSymbol(filterSymbol, input, item) {
          var updatedItem = item;
          var query = gl.DropdownUtils.getSearchInput(input);

          var _gl$FilteredSearchTok = gl.FilteredSearchTokenizer.processTokens(query),
              lastToken = _gl$FilteredSearchTok.lastToken,
              searchToken = _gl$FilteredSearchTok.searchToken;

          if (lastToken !== searchToken) {
            var title = updatedItem.title.toLowerCase();
            var value = lastToken.value.toLowerCase();

            // Removes the first character if it is a quotation so that we can search
            // with multiple words
            if ((value[0] === '"' || value[0] === '\'') && title.indexOf(' ') !== -1) {
              value = value.slice(1);
            }

            // Eg. filterSymbol = ~ for labels
            var matchWithoutSymbol = lastToken.symbol === filterSymbol && title.indexOf(value) !== -1;
            var match = title.indexOf('' + lastToken.symbol + value) !== -1;

            updatedItem.droplab_hidden = !match && !matchWithoutSymbol;
          } else {
            updatedItem.droplab_hidden = false;
          }

          return updatedItem;
        }
      }, {
        key: 'filterHint',
        value: function filterHint(input, item) {
          var updatedItem = item;
          var query = gl.DropdownUtils.getSearchInput(input);

          var _gl$FilteredSearchTok2 = gl.FilteredSearchTokenizer.processTokens(query),
              lastToken = _gl$FilteredSearchTok2.lastToken;

          lastToken = lastToken.key || lastToken || '';

          if (!lastToken || query.split('').last() === ' ') {
            updatedItem.droplab_hidden = false;
          } else if (lastToken) {
            var split = lastToken.split(':');
            var tokenName = split[0].split(' ').last();

            var match = updatedItem.hint.indexOf(tokenName.toLowerCase()) === -1;
            updatedItem.droplab_hidden = tokenName ? match : false;
          }

          return updatedItem;
        }
      }, {
        key: 'setDataValueIfSelected',
        value: function setDataValueIfSelected(filter, selected) {
          var dataValue = selected.getAttribute('data-value');

          if (dataValue) {
            gl.FilteredSearchDropdownManager.addWordToInput(filter, dataValue);
          }

          // Return boolean based on whether it was set
          return dataValue !== null;
        }
      }, {
        key: 'getSearchInput',
        value: function getSearchInput(filteredSearchInput) {
          var inputValue = filteredSearchInput.value;

          var _gl$DropdownUtils$get = gl.DropdownUtils.getInputSelectionPosition(filteredSearchInput),
              right = _gl$DropdownUtils$get.right;

          return inputValue.slice(0, right);
        }
      }, {
        key: 'getInputSelectionPosition',
        value: function getInputSelectionPosition(input) {
          var selectionStart = input.selectionStart;
          var inputValue = input.value;
          // Replace all spaces inside quote marks with underscores
          // (will continue to match entire string until an end quote is found if any)
          // This helps with matching the beginning & end of a token:key
          inputValue = inputValue.replace(/(('[^']*'{0,1})|("[^"]*"{0,1})|:\s+)/g, function (str) {
            return str.replace(/\s/g, '_');
          });

          // Get the right position for the word selected
          // Regex matches first space
          var right = inputValue.slice(selectionStart).search(/\s/);

          if (right >= 0) {
            right += selectionStart;
          } else if (right < 0) {
            right = inputValue.length;
          }

          // Get the left position for the word selected
          // Regex matches last non-whitespace character
          var left = inputValue.slice(0, right).search(/\S+$/);

          if (selectionStart === 0) {
            left = 0;
          } else if (selectionStart === inputValue.length && left < 0) {
            left = inputValue.length;
          } else if (left < 0) {
            left = selectionStart;
          }

          return {
            left: left,
            right: right
          };
        }
      }]);

      return DropdownUtils;
    }();

    window.gl = window.gl || {};
    gl.DropdownUtils = DropdownUtils;
  })();
}).call(window);

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global DropLab */

  (function () {
    var FilteredSearchDropdownManager = function () {
      function FilteredSearchDropdownManager() {
        var baseEndpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        _classCallCheck(this, FilteredSearchDropdownManager);

        this.baseEndpoint = baseEndpoint.replace(/\/$/, '');
        this.tokenizer = gl.FilteredSearchTokenizer;
        this.filteredSearchInput = document.querySelector('.filtered-search');

        this.setupMapping();

        this.cleanupWrapper = this.cleanup.bind(this);
        document.addEventListener('beforeunload', this.cleanupWrapper);
      }

      _createClass(FilteredSearchDropdownManager, [{
        key: 'cleanup',
        value: function cleanup() {
          if (this.droplab) {
            this.droplab.destroy();
            this.droplab = null;
          }

          this.setupMapping();

          document.removeEventListener('beforeunload', this.cleanupWrapper);
        }
      }, {
        key: 'setupMapping',
        value: function setupMapping() {
          this.mapping = {
            author: {
              reference: null,
              gl: 'DropdownUser',
              element: document.querySelector('#js-dropdown-author')
            },
            assignee: {
              reference: null,
              gl: 'DropdownUser',
              element: document.querySelector('#js-dropdown-assignee')
            },
            milestone: {
              reference: null,
              gl: 'DropdownNonUser',
              extraArguments: [this.baseEndpoint + '/milestones.json', '%'],
              element: document.querySelector('#js-dropdown-milestone')
            },
            label: {
              reference: null,
              gl: 'DropdownNonUser',
              extraArguments: [this.baseEndpoint + '/labels.json', '~'],
              element: document.querySelector('#js-dropdown-label')
            },
            hint: {
              reference: null,
              gl: 'DropdownHint',
              element: document.querySelector('#js-dropdown-hint')
            }
          };
        }
      }, {
        key: 'updateCurrentDropdownOffset',
        value: function updateCurrentDropdownOffset() {
          this.updateDropdownOffset(this.currentDropdown);
        }
      }, {
        key: 'updateDropdownOffset',
        value: function updateDropdownOffset(key) {
          if (!this.font) {
            this.font = window.getComputedStyle(this.filteredSearchInput).font;
          }

          var input = this.filteredSearchInput;
          var inputText = input.value.slice(0, input.selectionStart);
          var filterIconPadding = 27;
          var offset = gl.text.getTextWidth(inputText, this.font) + filterIconPadding;

          var currentDropdownWidth = this.mapping[key].element.clientWidth === 0 ? 200 : this.mapping[key].element.clientWidth;
          var offsetMaxWidth = this.filteredSearchInput.clientWidth - currentDropdownWidth;

          if (offsetMaxWidth < offset) {
            offset = offsetMaxWidth;
          }

          this.mapping[key].reference.setOffset(offset);
        }
      }, {
        key: 'load',
        value: function load(key) {
          var firstLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

          var mappingKey = this.mapping[key];
          var glClass = mappingKey.gl;
          var element = mappingKey.element;
          var forceShowList = false;

          if (!mappingKey.reference) {
            var dl = this.droplab;
            var defaultArguments = [null, dl, element, this.filteredSearchInput, key];
            var glArguments = defaultArguments.concat(mappingKey.extraArguments || []);

            // Passing glArguments to `new gl[glClass](<arguments>)`
            mappingKey.reference = new (Function.prototype.bind.apply(gl[glClass], glArguments))();
          }

          if (firstLoad) {
            mappingKey.reference.init();
          }

          if (this.currentDropdown === 'hint') {
            // Force the dropdown to show if it was clicked from the hint dropdown
            forceShowList = true;
          }

          this.updateDropdownOffset(key);
          mappingKey.reference.render(firstLoad, forceShowList);

          this.currentDropdown = key;
        }
      }, {
        key: 'loadDropdown',
        value: function loadDropdown() {
          var dropdownName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

          var firstLoad = false;

          if (!this.droplab) {
            firstLoad = true;
            this.droplab = new DropLab();
          }

          var match = gl.FilteredSearchTokenKeys.searchByKey(dropdownName.toLowerCase());
          var shouldOpenFilterDropdown = match && this.currentDropdown !== match.key && this.mapping[match.key];
          var shouldOpenHintDropdown = !match && this.currentDropdown !== 'hint';

          if (shouldOpenFilterDropdown || shouldOpenHintDropdown) {
            var key = match && match.key ? match.key : 'hint';
            this.load(key, firstLoad);
          }
        }
      }, {
        key: 'setDropdown',
        value: function setDropdown() {
          var _tokenizer$processTok = this.tokenizer.processTokens(gl.DropdownUtils.getSearchInput(this.filteredSearchInput)),
              lastToken = _tokenizer$processTok.lastToken,
              searchToken = _tokenizer$processTok.searchToken;

          if (this.currentDropdown) {
            this.updateCurrentDropdownOffset();
          }

          if (lastToken === searchToken && lastToken !== null) {
            // Token is not fully initialized yet because it has no value
            // Eg. token = 'label:'

            var split = lastToken.split(':');
            var dropdownName = split[0].split(' ').last();
            this.loadDropdown(split.length > 1 ? dropdownName : '');
          } else if (lastToken) {
            // Token has been initialized into an object because it has a value
            this.loadDropdown(lastToken.key);
          } else {
            this.loadDropdown('hint');
          }
        }
      }, {
        key: 'resetDropdowns',
        value: function resetDropdowns() {
          // Force current dropdown to hide
          this.mapping[this.currentDropdown].reference.hideDropdown();

          // Re-Load dropdown
          this.setDropdown();

          // Reset filters for current dropdown
          this.mapping[this.currentDropdown].reference.resetFilters();

          // Reposition dropdown so that it is aligned with cursor
          this.updateDropdownOffset(this.currentDropdown);
        }
      }, {
        key: 'destroyDroplab',
        value: function destroyDroplab() {
          this.droplab.destroy();
        }
      }], [{
        key: 'addWordToInput',
        value: function addWordToInput(tokenName) {
          var tokenValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

          var input = document.querySelector('.filtered-search');
          var inputValue = input.value;
          var word = tokenName + ':' + tokenValue;

          // Get the string to replace
          var newCaretPosition = input.selectionStart;

          var _gl$DropdownUtils$get = gl.DropdownUtils.getInputSelectionPosition(input),
              left = _gl$DropdownUtils$get.left,
              right = _gl$DropdownUtils$get.right;

          input.value = '' + inputValue.substr(0, left) + word + inputValue.substr(right);

          // If we have added a tokenValue at the end of the input,
          // add a space and set selection to the end
          if (right >= inputValue.length && tokenValue !== '') {
            input.value += ' ';
            newCaretPosition = input.value.length;
          }

          gl.FilteredSearchDropdownManager.updateInputCaretPosition(newCaretPosition, input);
        }
      }, {
        key: 'updateInputCaretPosition',
        value: function updateInputCaretPosition(selectionStart, input) {
          // Reset the position
          // Sometimes can end up at end of input
          input.setSelectionRange(selectionStart, selectionStart);

          var _gl$DropdownUtils$get2 = gl.DropdownUtils.getInputSelectionPosition(input),
              right = _gl$DropdownUtils$get2.right;

          input.setSelectionRange(right, right);
        }
      }]);

      return FilteredSearchDropdownManager;
    }();

    window.gl = window.gl || {};
    gl.FilteredSearchDropdownManager = FilteredSearchDropdownManager;
  })();
}).call(window);

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    var FilteredSearchManager = function () {
      function FilteredSearchManager() {
        _classCallCheck(this, FilteredSearchManager);

        this.filteredSearchInput = document.querySelector('.filtered-search');
        this.clearSearchButton = document.querySelector('.clear-search');

        if (this.filteredSearchInput) {
          this.tokenizer = gl.FilteredSearchTokenizer;
          this.dropdownManager = new gl.FilteredSearchDropdownManager(this.filteredSearchInput.getAttribute('data-base-endpoint') || '');

          this.bindEvents();
          this.loadSearchParamsFromURL();
          this.dropdownManager.setDropdown();

          this.cleanupWrapper = this.cleanup.bind(this);
          document.addEventListener('beforeunload', this.cleanupWrapper);
        }
      }

      _createClass(FilteredSearchManager, [{
        key: 'cleanup',
        value: function cleanup() {
          this.unbindEvents();
          document.removeEventListener('beforeunload', this.cleanupWrapper);
        }
      }, {
        key: 'bindEvents',
        value: function bindEvents() {
          this.handleFormSubmit = this.handleFormSubmit.bind(this);
          this.setDropdownWrapper = this.dropdownManager.setDropdown.bind(this.dropdownManager);
          this.toggleClearSearchButtonWrapper = this.toggleClearSearchButton.bind(this);
          this.checkForEnterWrapper = this.checkForEnter.bind(this);
          this.clearSearchWrapper = this.clearSearch.bind(this);
          this.checkForBackspaceWrapper = this.checkForBackspace.bind(this);
          this.tokenChange = this.tokenChange.bind(this);

          this.filteredSearchInput.form.addEventListener('submit', this.handleFormSubmit);
          this.filteredSearchInput.addEventListener('input', this.setDropdownWrapper);
          this.filteredSearchInput.addEventListener('input', this.toggleClearSearchButtonWrapper);
          this.filteredSearchInput.addEventListener('keydown', this.checkForEnterWrapper);
          this.filteredSearchInput.addEventListener('keyup', this.checkForBackspaceWrapper);
          this.filteredSearchInput.addEventListener('click', this.tokenChange);
          this.filteredSearchInput.addEventListener('keyup', this.tokenChange);
          this.clearSearchButton.addEventListener('click', this.clearSearchWrapper);
        }
      }, {
        key: 'unbindEvents',
        value: function unbindEvents() {
          this.filteredSearchInput.form.removeEventListener('submit', this.handleFormSubmit);
          this.filteredSearchInput.removeEventListener('input', this.setDropdownWrapper);
          this.filteredSearchInput.removeEventListener('input', this.toggleClearSearchButtonWrapper);
          this.filteredSearchInput.removeEventListener('keydown', this.checkForEnterWrapper);
          this.filteredSearchInput.removeEventListener('keyup', this.checkForBackspaceWrapper);
          this.filteredSearchInput.removeEventListener('click', this.tokenChange);
          this.filteredSearchInput.removeEventListener('keyup', this.tokenChange);
          this.clearSearchButton.removeEventListener('click', this.clearSearchWrapper);
        }
      }, {
        key: 'checkForBackspace',
        value: function checkForBackspace(e) {
          // 8 = Backspace Key
          // 46 = Delete Key
          if (e.keyCode === 8 || e.keyCode === 46) {
            // Reposition dropdown so that it is aligned with cursor
            this.dropdownManager.updateCurrentDropdownOffset();
          }
        }
      }, {
        key: 'checkForEnter',
        value: function checkForEnter(e) {
          if (e.keyCode === 38 || e.keyCode === 40) {
            var selectionStart = this.filteredSearchInput.selectionStart;

            e.preventDefault();
            this.filteredSearchInput.setSelectionRange(selectionStart, selectionStart);
          }

          if (e.keyCode === 13) {
            var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];
            var dropdownEl = dropdown.element;
            var activeElements = dropdownEl.querySelectorAll('.dropdown-active');

            e.preventDefault();

            if (!activeElements.length) {
              // Prevent droplab from opening dropdown
              this.dropdownManager.destroyDroplab();

              this.search();
            }
          }
        }
      }, {
        key: 'toggleClearSearchButton',
        value: function toggleClearSearchButton(e) {
          if (e.target.value) {
            this.clearSearchButton.classList.remove('hidden');
          } else {
            this.clearSearchButton.classList.add('hidden');
          }
        }
      }, {
        key: 'clearSearch',
        value: function clearSearch(e) {
          e.preventDefault();

          this.filteredSearchInput.value = '';
          this.clearSearchButton.classList.add('hidden');

          this.dropdownManager.resetDropdowns();
        }
      }, {
        key: 'handleFormSubmit',
        value: function handleFormSubmit(e) {
          e.preventDefault();
          this.search();
        }
      }, {
        key: 'loadSearchParamsFromURL',
        value: function loadSearchParamsFromURL() {
          var params = gl.utils.getUrlParamsArray();
          var usernameParams = this.getUsernameParams();
          var inputValues = [];

          params.forEach(function (p) {
            var split = p.split('=');
            var keyParam = decodeURIComponent(split[0]);
            var value = split[1];

            // Check if it matches edge conditions listed in gl.FilteredSearchTokenKeys
            var condition = gl.FilteredSearchTokenKeys.searchByConditionUrl(p);

            if (condition) {
              inputValues.push(condition.tokenKey + ':' + condition.value);
            } else {
              // Sanitize value since URL converts spaces into +
              // Replace before decode so that we know what was originally + versus the encoded +
              var sanitizedValue = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : value;
              var match = gl.FilteredSearchTokenKeys.searchByKeyParam(keyParam);

              if (match) {
                var indexOf = keyParam.indexOf('_');
                var sanitizedKey = indexOf !== -1 ? keyParam.slice(0, keyParam.indexOf('_')) : keyParam;
                var symbol = match.symbol;
                var quotationsToUse = '';

                if (sanitizedValue.indexOf(' ') !== -1) {
                  // Prefer ", but use ' if required
                  quotationsToUse = sanitizedValue.indexOf('"') === -1 ? '"' : '\'';
                }

                inputValues.push(sanitizedKey + ':' + symbol + quotationsToUse + sanitizedValue + quotationsToUse);
              } else if (!match && keyParam === 'assignee_id') {
                var id = parseInt(value, 10);
                if (usernameParams[id]) {
                  inputValues.push('assignee:@' + usernameParams[id]);
                }
              } else if (!match && keyParam === 'author_id') {
                var _id = parseInt(value, 10);
                if (usernameParams[_id]) {
                  inputValues.push('author:@' + usernameParams[_id]);
                }
              } else if (!match && keyParam === 'search') {
                inputValues.push(sanitizedValue);
              }
            }
          });

          // Trim the last space value
          this.filteredSearchInput.value = inputValues.join(' ');

          if (inputValues.length > 0) {
            this.clearSearchButton.classList.remove('hidden');
          }
        }
      }, {
        key: 'search',
        value: function search() {
          var paths = [];

          var _tokenizer$processTok = this.tokenizer.processTokens(this.filteredSearchInput.value),
              tokens = _tokenizer$processTok.tokens,
              searchToken = _tokenizer$processTok.searchToken;

          var currentState = gl.utils.getParameterByName('state') || 'opened';
          paths.push('state=' + currentState);

          tokens.forEach(function (token) {
            var condition = gl.FilteredSearchTokenKeys.searchByConditionKeyValue(token.key, token.value.toLowerCase());

            var _ref = gl.FilteredSearchTokenKeys.searchByKey(token.key) || {},
                param = _ref.param;

            var keyParam = param ? token.key + '_' + param : token.key;
            var tokenPath = '';

            if (condition) {
              tokenPath = condition.url;
            } else {
              var tokenValue = token.value;

              if (tokenValue[0] === '\'' && tokenValue[tokenValue.length - 1] === '\'' || tokenValue[0] === '"' && tokenValue[tokenValue.length - 1] === '"') {
                tokenValue = tokenValue.slice(1, tokenValue.length - 1);
              }

              tokenPath = keyParam + '=' + encodeURIComponent(tokenValue);
            }

            paths.push(tokenPath);
          });

          if (searchToken) {
            var sanitized = searchToken.split(' ').map(function (t) {
              return encodeURIComponent(t);
            }).join('+');
            paths.push('search=' + sanitized);
          }

          var parameterizedUrl = '?scope=all&utf8=\u2713&' + paths.join('&');

          gl.utils.visitUrl(parameterizedUrl);
        }
      }, {
        key: 'getUsernameParams',
        value: function getUsernameParams() {
          var usernamesById = {};
          try {
            var attribute = this.filteredSearchInput.getAttribute('data-username-params');
            JSON.parse(attribute).forEach(function (user) {
              usernamesById[user.id] = user.username;
            });
          } catch (e) {
            // do nothing
          }
          return usernamesById;
        }
      }, {
        key: 'tokenChange',
        value: function tokenChange() {
          var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];
          var currentDropdownRef = dropdown.reference;

          this.setDropdownWrapper();
          currentDropdownRef.dispatchInputEvent();
        }
      }]);

      return FilteredSearchManager;
    }();

    window.gl = window.gl || {};
    gl.FilteredSearchManager = FilteredSearchManager;
  })();
}).call(window);

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  __webpack_require__(33);

  (function () {
    var FilteredSearchTokenizer = function () {
      function FilteredSearchTokenizer() {
        _classCallCheck(this, FilteredSearchTokenizer);
      }

      _createClass(FilteredSearchTokenizer, null, [{
        key: 'processTokens',
        value: function processTokens(input) {
          var allowedKeys = gl.FilteredSearchTokenKeys.get().map(function (i) {
            return i.key;
          });
          // Regex extracts `(token):(symbol)(value)`
          // Values that start with a double quote must end in a double quote (same for single)
          var tokenRegex = new RegExp('(' + allowedKeys.join('|') + '):([~%@]?)(?:(\'[^\']*\'{0,1})|("[^"]*"{0,1})|(\\S+))', 'g');
          var tokens = [];
          var lastToken = null;
          var searchToken = input.replace(tokenRegex, function (match, key, symbol, v1, v2, v3) {
            var tokenValue = v1 || v2 || v3;
            var tokenSymbol = symbol;

            if (tokenValue === '~' || tokenValue === '%' || tokenValue === '@') {
              tokenSymbol = tokenValue;
              tokenValue = '';
            }

            tokens.push({
              key: key,
              value: tokenValue || '',
              symbol: tokenSymbol || ''
            });
            return '';
          }).replace(/\s{2,}/g, ' ').trim() || '';

          if (tokens.length > 0) {
            var last = tokens[tokens.length - 1];
            var lastString = last.key + ':' + last.symbol + last.value;
            lastToken = input.lastIndexOf(lastString) === input.length - lastString.length ? last : searchToken;
          } else {
            lastToken = searchToken;
          }

          return {
            tokens: tokens,
            lastToken: lastToken,
            searchToken: searchToken
          };
        }
      }]);

      return FilteredSearchTokenizer;
    }();

    window.gl = window.gl || {};
    gl.FilteredSearchTokenizer = FilteredSearchTokenizer;
  })();
}).call(window);

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dropdown_hint.js": 109,
	"./dropdown_hint.js.es6": 109,
	"./dropdown_non_user.js": 110,
	"./dropdown_non_user.js.es6": 110,
	"./dropdown_user.js": 111,
	"./dropdown_user.js.es6": 111,
	"./dropdown_utils.js": 112,
	"./dropdown_utils.js.es6": 112,
	"./filtered_search_dropdown.js": 11,
	"./filtered_search_dropdown.js.es6": 11,
	"./filtered_search_dropdown_manager.js": 113,
	"./filtered_search_dropdown_manager.js.es6": 113,
	"./filtered_search_manager.js": 114,
	"./filtered_search_manager.js.es6": 114,
	"./filtered_search_token_keys.js": 33,
	"./filtered_search_token_keys.js.es6": 33,
	"./filtered_search_tokenizer.js": 115,
	"./filtered_search_tokenizer.js.es6": 115
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;


/***/ }),

/***/ 33:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    var tokenKeys = [{
      key: 'author',
      type: 'string',
      param: 'username',
      symbol: '@'
    }, {
      key: 'assignee',
      type: 'string',
      param: 'username',
      symbol: '@'
    }, {
      key: 'milestone',
      type: 'string',
      param: 'title',
      symbol: '%'
    }, {
      key: 'label',
      type: 'array',
      param: 'name[]',
      symbol: '~'
    }];

    var alternativeTokenKeys = [{
      key: 'label',
      type: 'string',
      param: 'name',
      symbol: '~'
    }];

    var tokenKeysWithAlternative = tokenKeys.concat(alternativeTokenKeys);

    var conditions = [{
      url: 'assignee_id=0',
      tokenKey: 'assignee',
      value: 'none'
    }, {
      url: 'milestone_title=No+Milestone',
      tokenKey: 'milestone',
      value: 'none'
    }, {
      url: 'milestone_title=%23upcoming',
      tokenKey: 'milestone',
      value: 'upcoming'
    }, {
      url: 'label_name[]=No+Label',
      tokenKey: 'label',
      value: 'none'
    }];

    var FilteredSearchTokenKeys = function () {
      function FilteredSearchTokenKeys() {
        _classCallCheck(this, FilteredSearchTokenKeys);
      }

      _createClass(FilteredSearchTokenKeys, null, [{
        key: 'get',
        value: function get() {
          return tokenKeys;
        }
      }, {
        key: 'getAlternatives',
        value: function getAlternatives() {
          return alternativeTokenKeys;
        }
      }, {
        key: 'getConditions',
        value: function getConditions() {
          return conditions;
        }
      }, {
        key: 'searchByKey',
        value: function searchByKey(key) {
          return tokenKeys.find(function (tokenKey) {
            return tokenKey.key === key;
          }) || null;
        }
      }, {
        key: 'searchBySymbol',
        value: function searchBySymbol(symbol) {
          return tokenKeys.find(function (tokenKey) {
            return tokenKey.symbol === symbol;
          }) || null;
        }
      }, {
        key: 'searchByKeyParam',
        value: function searchByKeyParam(keyParam) {
          return tokenKeysWithAlternative.find(function (tokenKey) {
            var tokenKeyParam = tokenKey.key;

            if (tokenKey.param) {
              tokenKeyParam += '_' + tokenKey.param;
            }

            return keyParam === tokenKeyParam;
          }) || null;
        }
      }, {
        key: 'searchByConditionUrl',
        value: function searchByConditionUrl(url) {
          return conditions.find(function (condition) {
            return condition.url === url;
          }) || null;
        }
      }, {
        key: 'searchByConditionKeyValue',
        value: function searchByConditionKeyValue(key, value) {
          return conditions.find(function (condition) {
            return condition.tokenKey === key && condition.value === value;
          }) || null;
        }
      }]);

      return FilteredSearchTokenKeys;
    }();

    window.gl = window.gl || {};
    gl.FilteredSearchTokenKeys = FilteredSearchTokenKeys;
  })();
}).call(window);

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  function requireAll(context) {
    return context.keys().map(context);
  }

  requireAll(__webpack_require__(174));
}).call(window);

/***/ })

/******/ });


// WEBPACK FOOTER //
// filtered_search-a9686c202b6d47f27ac6-v2.js